export const obtenerDia = (dia) => {



    let dias = ['Domingo', 'Lunes', 'Martes', 'Miercoles', 'Jueves', 'Viernes', 'Sabado']

    return dias[dia]

}